export default function copyToClipboard (data) {
  navigator.clipboard.writeText(data);
}
